import { PropsWithChildren, useEffect, useState } from "react";
import { RendererProps } from "./types";

export function TextRenderer({
	url,
	children,
}: PropsWithChildren<RendererProps>): React.ReactElement {
	const [content, setContent] = useState("");

	useEffect(() => {
		const loadText = async (): Promise<void> => {
			try {
				const response = await fetch(url);
				const text = await response.text();
				setContent(text);
			} catch (error) {
				// TODO: handle error
			}
		};

		loadText().catch(() => {
			// TODO: handle error
		});
	}, [url]);

	return (
		<div className="h-[calc(90vh-100px)] p-lg overflow-y-auto">
			<div className="w-[80%] max-w-[960px] mx-auto">
				<pre className="w-full h-full whitespace-pre-wrap rounded-md bg-white text-black px-16 pt-12 pb-20 font-mono">
					{content}
				</pre>
			</div>
			{children}
		</div>
	);
}
